import { Settings, Task, PriceCheck, RequestQuote, People, QueryStats, History, AdminPanelSettings } from "@mui/icons-material";

const icons = {
    Settings, Task, PriceCheck, RequestQuote, People, QueryStats, History, AdminPanelSettings
}

// ==============================|| ADMIN PAGES MENU ITEMS ||============================== //

const administracion = {
    id: 'administracion',
    type: 'group',
    children: [
        {
            id: 'administracion-menu',
            title: 'Administración',
            type: 'collapse',
            icon: icons.Settings,
            children: [
                {
                    id: 'tiposContrato',
                    title: 'Tipos de Contrato',
                    type: 'item',
                    icon: icons.Task,
                    url: '/administracion/tiposContrato',
                    target: false
                },
                {
                    id: 'regimenFiscal',
                    title: 'Régimen Fiscal',
                    type: 'item',
                    icon: icons.PriceCheck,
                    url: '/administracion/regimenFiscal',
                    target: false
                },
                {
                    id: 'usoCFDI',
                    title: 'Uso de CFDI',
                    type: 'item',
                    icon: icons.RequestQuote,
                    url: '/administracion/usoCFDI',
                    target: false
                },
                {
                    id: 'usuarios',
                    title: 'Usuarios',
                    type: 'item',
                    icon: icons.People,
                    url: '/administracion/usuarios',
                    target: false
                },
                {
                    id: 'actividadUsuarios',
                    title: 'Actividad de Usuarios',
                    type: 'item',
                    icon: icons.QueryStats,
                    url: '/administracion/actividad-usuarios',
                    target: false
                },
                {
                    id: 'gestionHistoria',
                    title: 'Gestión de Historia',
                    type: 'item',
                    icon: icons.History,
                    url: '/administracion/gestion-historia',
                    target: false
                },
                {
                    id: 'gestionAdmins',
                    title: 'Gestión de Administradores',
                    type: 'item',
                    icon: icons.AdminPanelSettings,
                    url: '/administracion/gestion-admins',
                    target: false
                },
            ]
        }
    ]
};

export default administracion;
